

































































import {Component, Mixins} from "vue-property-decorator";
import Dialog from "@/mixins/Dialog";
import ConfirmDialog from "@/components/confirmDialog.vue";

@Component({
  components: {
    'confirm-dialog' : ConfirmDialog
  }
})
export default class CompanyApplyDialog extends Mixins(Dialog){

  //弹窗显示
  private dialog:any={
    confirmDialog:false
  }

  // 表单参数
  private params:any={
    organ_name: "",
    type: 2,
    code: "",
    legal_name: "",
    contact: "",
    email: "",
    operations: "",
    dilemma_requirement: "",
    plat_id: 76
  }

  //校验参数
  private rules:any={
    organ_name: [
      {required: true, message: '请输入企业名称', trigger: 'blur'}
    ],
    code: [
      {required: true, message: '请输入统一社会信用代码', trigger: 'blur'}
    ],
    legal_name: [
      {required: true, message: '请输入法人姓名', trigger: 'blur'}
    ],
    contact: [
      {required: true, message: '请输入联系方式', trigger: 'blur'}
    ],
    email: [
      {required: true, message: '请输入邮箱', trigger: 'blur'}
    ],
    operations: [
      {required: true, message: '请输入运行状况', trigger: 'blur'}
    ],
    dilemma_requirement: [
      {required: true, message: '请输入困境需求描述', trigger: 'blur'}
    ]
  }

  public open(){
    this.dialog_visible = true ;
  }

  //提交
  private submit(){

    let form = (this.$refs as any).dialog_form;
    form.validate((valid:any) => {
      if (valid) {
        let data :any={};
        Object.assign( data, this.params );
        console.log( data , '纾困企业申请' );
        this.loading = true;
        this.$noSign.post(this.$URL.ENTERPRISE_APPLY , data ).then((res:any)=>{
          this.loading = false;
          if(res.code == 1){
            console.log( res , data, '纾困企业申请成功');
            (this.$refs as any).confirmDialog.open( '提交成功，待审核' , 'success' )
          }else{
            this.$message.error( res.msg )
          }
        })
      }
    });
  }

  private complete(){
    this.onClose();
  }

  public onClose(){
    let form = (this.$refs as any).dialog_form;
    form.resetFields();
    this.dialog_visible = false ;
  }
}
